var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"link"},[_c('img',{attrs:{"src":require("@/assets/link-icon.svg")}}),_c('a',{staticClass:"link",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }